<template>
  <div class="main">
    <router-view v-slot="{ Component }" v-if="auth">
      <transition name="fade" mode="out-in">
        <component :is="Component" />
      </transition>
    </router-view>
    <div v-else-if="auth === null">Loading</div>
    <Login v-else />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import Login from "@/components/Login.vue";
import { SHA256 } from "crypto-js";

function sleep(ms:number = 1000){
  return new Promise((resolve, reject)=>{
    window.setTimeout(resolve, ms);
  });
}

export default defineComponent({
  name: "App",
  components:{
    Login
  },
  data():{
    auth: boolean | null,
  }{
    return{
      auth: null,
    }
  },
  mounted(){
    this.checkLogin();
  },
  methods: {
    checkLogin(){
      const query: {[key:string] : string} = {};
      location.search.replace('?','').split('&').forEach(element => {
        const parts = element.split('=');
        if(parts[1]){
          query[parts[0]] = parts[1];
        }
      });
      if(query.pass){
        localStorage.setItem('password', query.pass);
      }
      
      const savedPassword = localStorage.getItem('password') || '';
      if(SHA256(savedPassword).toString() === 'ca1a0b5a884c5056744095a293afb73e5742de50abbe0ff134586f50673b40c1'){
        this.auth = true;
      } else {
        this.auth = false;
      }
    }
  }
});
</script>

<style scoped>
.main {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background: #000;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(0deg, rgba(79,79,79,1) 0%, rgba(0,0,0,1) 7%, rgba(0,0,0,1) 93%, rgba(79,79,79,1) 100%);
}
.logo {
  top: 5vh;
  width: 16.59vh;
  height: 5vh;
  background: url("/img/logo_beta.svg") center center no-repeat;
  background-size: contain;
  position: absolute;
  z-index: 1;
}
.miptv {
  top: 0px;
  width: 16.24vh;
  height: 14vh;
  left: calc(50% + 27vh);
  background: url("/img/miptv.png") center center no-repeat;
  background-size: contain;
  position: absolute;
}
</style>
